import type { FlowScreen, FlowAnswers } from "@/shared/constants/flowTypes";

export function getVisibleScreens(
  screens: readonly FlowScreen[],
  answers: FlowAnswers,
): FlowScreen[] {
  return screens.filter((screen) => {
    if (!screen.shouldDisplay) return true;
    return screen.shouldDisplay({ answers, currentStep: 0 });
  });
}

export function getVisibleScreenIndex(
  screenId: string,
  screens: readonly FlowScreen[],
  answers: FlowAnswers,
): number {
  const visibleScreens = getVisibleScreens(screens, answers);
  const index = visibleScreens.findIndex((s) => s.id === screenId);
  return index >= 0 ? index : 0;
}

export function getNextScreenId(
  currentScreenId: string,
  screens: readonly FlowScreen[],
  answers: FlowAnswers,
): string {
  const visibleScreens = getVisibleScreens(screens, answers);
  const currentIndex = visibleScreens.findIndex((s) => s.id === currentScreenId);
  const nextScreen = visibleScreens[currentIndex + 1];
  return nextScreen ? nextScreen.id : currentScreenId;
}
